import { FC, Fragment, ReactNode } from 'react';
import cn from 'classnames';
import { kebabCase } from 'lodash';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import './RecordMetadata.scss';

export type MetadataItem = {
  content: ReactNode;
  title?: string;
  testId?: string;
};

interface RecordMetadataProps {
  items: MetadataItem[];
}

const cnBem = createBemBlockBuilder(['recordMetadata']);

export const RecordMetadata: FC<RecordMetadataProps> = ({ items }) => (
  <article className={cnBem()}>
    <div>
      {items.map(({ title = '', content, testId = kebabCase(title) }) => (
        <Fragment key={title + testId}>
          {title && (
            <div
              className={cn(cnBem('__title'), cnBem(`__${testId}Title`))}
              data-auto={`record-${testId}-title`}
            >
              <h3>{title}</h3>
            </div>
          )}
          <div
            className={cn(cnBem('__content'), cnBem(`__${testId}Content`))}
            dir="ltr"
            data-auto={`record-${testId}-content`}
          >
            {content}
          </div>
        </Fragment>
      ))}
    </div>
  </article>
);
